import React from "react";
import FilterFields from "./fields/FilterFields";

export default function AssetFieldFiltersDisplay() {
  return <FilterFields name="assetFieldFilters" />;
} 